import React from 'react';

export const NextSlideSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2799 6.05591L5.73666 0.394931C5.61512 0.269791 5.47052 0.170464 5.3112 0.102681C5.15189 0.0348978 4.98101 0 4.80842 0C4.63583 0 4.46494 0.0348978 4.30563 0.102681C4.14631 0.170464 4.00171 0.269791 3.88018 0.394931C3.63668 0.645086 3.5 0.983479 3.5 1.3362C3.5 1.68893 3.63668 2.02732 3.88018 2.27747L8.5083 7.00386L3.88018 11.7302C3.63668 11.9804 3.5 12.3188 3.5 12.6715C3.5 13.0242 3.63668 13.3626 3.88018 13.6128C4.00234 13.7365 4.14722 13.8344 4.3065 13.9009C4.46579 13.9673 4.63636 14.001 4.80842 14C4.98048 14.001 5.15104 13.9673 5.31033 13.9009C5.46962 13.8344 5.61449 13.7365 5.73666 13.6128L11.2799 7.95181C11.4025 7.82769 11.4997 7.68002 11.5661 7.51732C11.6325 7.35462 11.6667 7.18011 11.6667 7.00386C11.6667 6.82761 11.6325 6.6531 11.5661 6.4904C11.4997 6.3277 11.4025 6.18003 11.2799 6.05591Z"
      fill="#282F33"
    />
  </svg>
);

export default NextSlideSvg;
